module.exports = __webpack_public_path__ + "img/timeline_mainevent-8.9e1c8548.jpg";